module.exports = __webpack_public_path__ + "static/img/legend_english.d9c9c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_english.png
// module id = brKA
// module chunks = 94